// extracted by mini-css-extract-plugin
export var chevron = "_3f-d";
export var disabled = "_3f-b";
export var error = "_3f-c";
export var hideBorder = "_3f-1";
export var icon = "_3f-e";
export var input = "_3f-0";
export var open = "_3f-9";
export var placeholder = "_3f-a";
export var regular = "_3f-5";
export var singleRowInput = "_3f-2";
export var singleSelectInput = "_3f-3 _3f-0";
export var small = "_3f-4";
export var spinnerContainer = "_3f-g";
export var tag = "_3f-7";
export var tagsContainer = "_3f-8";
export var tagsInput = "_3f-6 _3f-0";
export var xSmall = "_3f-f";